<template>
  <div>
  	<div class="error" v-if="error" v-html="error"></div>
  	<div v-if="submitted">
  		<h3>Thank you, your enquiry has been received</h3>
  	</div>
  	<div v-else>
  		<b-form v-if="Object.keys(formElements).length > 0" :novalidate="trueBoolHTML" :validated="trueBool" ref="webformTag">
	  		<div v-for="(field, findex) in formElements" :key="findex"  :class="[field['#type'], field['error']]">
	    		<div class="label" v-if="field['#type'] != 'webform_location_geocomplete'">{{ field['#title'] }} <span v-if="field['#required']">*</span></div>
	    		<div v-if="field['#type'] == 'textfield'">
	    			<b-form-input type="text" v-model="form[field['#webform_key']]" :required="field['#required']"></b-form-input>
	    		</div>
	    		<div v-if="field['#type'] == 'email'">
	    			<b-form-input type="email" v-model="form[field['#webform_key']]" :required="field['#required']"></b-form-input>
	    		</div>
	    		<div v-if="field['#type'] == 'textarea'">
	    			<b-form-textarea v-model="form[field['#webform_key']]" :rows="field['#rows']" :required="field['#required']"></b-form-textarea>
	    		</div>
	    		
	    		<div v-if="field['#type'] == 'select'">
	    			<select v-if="!field['#multiple']" v-model="form[field['#webform_key']]" :required="field['#required']">
	    				<option v-for="(option, oindex) in field['#options']" :value="oindex" :key="oindex">{{ option }}</option>
	    			</select>
	    			<div v-else>
	    				<b-form-checkbox-group  v-model="form[field['#webform_key']]" :required="field['#required']">
	    					<b-form-checkbox  v-for="(option, oindex) in field['#options']" :key="oindex" :value="option">{{ option }}</b-form-checkbox>
		    			</b-form-checkbox-group>
	    			</div>
	    			<!-- {{ field['#multiple'] }} -->
	    			
	    		</div>
	    		<div v-if="field['#type'] == 'date'">
	    			<input type="date" :name="field['#webform_key']" v-model="form[field['#webform_key']]" :required="field['#required']" >
	    		</div>
	    		<!-- {{ selectedTimestamp[field['#webform_key']] }} -->

	    		<div v-if="field['#type'] == 'webform_document_file'">
		    		<b-form-file
				      v-model="form[field['#webform_key']]"
				      :ref="field['#webform_key']"
				      drop-placeholder="Drop file here..."
				      :required="field['#required']"
				      :class="(uploadError && uploadError[field['#webform_key']]) ? 'errorfield' : ''"
				    ></b-form-file>
				    <div class="field-instructions">
					    <div>Maximum File Size: {{ field['#max_filesize'] }}MB</div>
					    <div>Allowed File Type(s): {{ field['#file_extensions'] }}</div>
				    </div>
				    <div class="error" v-if="uploadError && uploadError[field['#webform_key']]">{{ uploadError[field['#webform_key']] }}</div>
				</div>
	    		
	    	</div>
	    	<p>&nbsp;</p>
	      	<p>&nbsp;</p>
	      	<b-button type="button" @click="submitWebform()" variant="secondary" class="btn-lg btn-block" :disabled="showSubmitLoader">Submit &raquo; <i class="fas fa-spinner fa-spin" v-if="showSubmitLoader"></i></b-button>
	      </b-form>
    </div>
  </div>
</template>
<script>

	import { RepositoryFactory } from "@/repositories/RepositoryFactory"
	const ContentRepository = RepositoryFactory.get("content");

	export default {
	  name: "applymodal",
	  data: function(){
	  	return {
	  		form: {},	
	  		formElements: {},
	  		hasError: {},
	  		trueVar: true,
        	preferredCountries: ['NG'],  
        	error: null,
        	webformKey: 'contact_us',
        	errorfield: '',
        	trueBool: false,
        	trueBoolHTML: true,
        	uploadError: null,
        	submitted: false,
        	webformTag: {},
        	showSubmitLoader: false	

	  	}
	  },
	  methods: {

	    async submitWebform(){
	    	this.showSubmitLoader = true
	    	this.error = null
	  		this.hasError = {}

	  		var isValid = this.$refs.webformTag.checkValidity()

	  		this.trueBool = true

	  		if (!isValid){
	  			this.error = "Please fill in all required fields highlighted below."
	  			this.showSubmitLoader = false
	  		} else {

	  			var postData = {
	  				webform_id: this.webformKey
	  			}
	  			var formKeys = Object.keys(this.formElements)

	  			for (var i = 0; i < formKeys.length; i++){
	  				var key = formKeys[i]
	  				var type = this.formElements[key]['#type']

	  				if (type == "webform_document_file" && this.form[key]){
	  					var validFile = this.validateFile(this.form[key], key)
	  					console.log('valid file', validFile)
	  					if (!validFile){
	  						this.showSubmitLoader = false
	  						return false
	  						break
	  					}
	  					// return this.validateFile(this.form[key], key)
	  				}
	  				postData[key] = this.form[key]
	  			}

	  			const { data } = await ContentRepository.submitWebform(postData)

	  			if (data){
	  				this.showSubmitLoader = false
	  				if (data.error){
	  					var errorKeys = Object.keys(data.error)
	  					this.error = "<ul>"
	  					for (var j = 0; j < errorKeys.length; j++){
	  						this.error += '<li>' + data.error[errorKeys[j]] + '</li>'
	  					}
	  					this.error += "</ul>"
	  				} else {
	  					this.submitted = true	
	  				}
	  				// this.submitted = true
	  			}
	  			

	  		}


	    },
	    validateFile(file, key){

	    	if (!this.uploadError){
	    		this.uploadError = {}
	    	}
	  		this.error = null

	        var allowedFiles = this.formElements[key]['#file_extensions'].split(' ')
	        var fileExtension = file.name.split('.').pop().toLowerCase()
	        var maxfileSizeMB = this.formElements[key]['#max_filesize']
	        var maxFileSize = Number(this.formElements[key]['#max_filesize']) * 1048576
	  
	        if (allowedFiles.indexOf(fileExtension) < 0){
	          this.error = `Your file type is not allowed for '${this.formElements[key]['#title']}', please upload a document (${allowedFiles})`  
	          return false
	        }  


	        if (file.size > maxFileSize){
	          this.error = `Your file size for '${this.formElements[key]['#title']}' is too large, please upload a document smaller than ${maxfileSizeMB}MB`
	          return false
	        } 

	        return true
	    },
	    async loadForm(id){
	    	const { data } = await ContentRepository.getWebform(id)
	    	this.formElements = data

	    }
	  
	  },
	  mounted(){
	  	this.loadForm(this.webformKey)
	  	// this.getToken()
	  	
	  }
	};
</script>
<style scoped>
	.error{
		padding:10px;
		color:#CC0000;
		border:1px dotted #CC0000;
		border-radius:5px;
		margin-bottom:15px;
	}

	.errorfield {
		border:2px solid #CC0000 !important;
	}

	.is-invalid{
		border:2px solid red !important;
	}

	.field-instructions{
		color:#666;
		font-style:italic;
		font-size:80%;
	}
</style>